import rarityFilterConfig from './rarity';
import colorFilterConfig from './color';
import cardTypeFilterConfig from './card-type';
import manaCostConfig from './mana-cost';
import wishlistedConfig from './wishlisted';

export default [
  rarityFilterConfig,
  colorFilterConfig,
  cardTypeFilterConfig,
  manaCostConfig,
  wishlistedConfig,
];
